import React from 'react';
import { TimeRangePicker } from '@grafana/ui';
import { SceneObjectBase } from '../core/SceneObjectBase.js';
import { sceneGraph } from '../core/sceneGraph.js';

class SceneTimePicker extends SceneObjectBase {
}
SceneTimePicker.Component = SceneTimePickerRenderer;
function SceneTimePickerRenderer({ model }) {
  const { hidePicker, isOnCanvas } = model.useState();
  const timeRange = sceneGraph.getTimeRange(model);
  const timeRangeState = timeRange.useState();
  if (hidePicker) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(TimeRangePicker, {
    isOnCanvas,
    value: timeRangeState.value,
    onChange: timeRange.onTimeRangeChange,
    timeZone: "browser",
    fiscalYearStartMonth: 0,
    onMoveBackward: () => {
    },
    onMoveForward: () => {
    },
    onZoom: () => {
    },
    onChangeTimeZone: () => {
    },
    onChangeFiscalYearStartMonth: () => {
    }
  });
}

export { SceneTimePicker };
//# sourceMappingURL=SceneTimePicker.js.map
